import { CellProps } from 'react-table';
import EditableCell from '../../modals/modal-chi-dinh-dich-vu/cells/EditableCell';
import AutocompleteV2 from '../../../component/AutocompleteObjectV2';
import { useEffect, useState } from 'react';
import { getTermServiceType } from '../../services/KhamBenhService';
import { TERM_CLASS_IDS } from '../../../utils/Constant';

const TermCell = ({ row, tableOptions }: CellProps<any>) => {
    const { handleChangeCongKham } = tableOptions;
    const rowData = row.original;
    const [listCongKham, setListCongKham] = useState<any>([]);

    const handleGetListCongKham = async () => {
        try {
            const { data } = await getTermServiceType({
                deptLaboratoryCode: rowData?.fulfillDeptCode,
                classIds: TERM_CLASS_IDS.KHAM_BENH,
                isSet: false
            });
            setListCongKham(data?.data || []);
        } catch (error) {
            console.error(error);
        }
    };
    
    useEffect(() => {
        handleGetListCongKham();
    }, []);

    return (
        <EditableCell
            editComponent={({ setEnableEditing }: any) => {
                return (
                    <AutocompleteV2
                        autoFocus
                        options={listCongKham || []}
                        value={{
                            id: rowData?.termId,
                            name: rowData?.termName,
                        }}
                        name="term"
                        getOptionValue={(option: any) => option.code}
                        onChange={(selectedOption) => {
                            handleChangeCongKham(rowData?.id, selectedOption?.id);
                            setEnableEditing(false);
                        }}
                        onBlur={() => {
                            setEnableEditing(false);
                        }}
                        isClearable={false}
                    />
                );
            }}
            textValue={rowData?.termName}
        />
    );
};

export default TermCell;
